import imageUrlBuilder from '@sanity/image-url'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import client from '@lib/sanity'

const MemberLink = ({ member, children }) => {
  if (!member.slug) return children
  return (
    <Link href="/members/[slug]" as={`/members/${member.slug.current}`}>
      <a className="block font-medium">{children}</a>
    </Link>
  )
}

const RegionLink = ({ region, children }) => {
  return (
    <Link
      href="/members/region/[slug]"
      as={`/members/region/${region.slug.current}`}
    >
      <a className="text-primary-200">{children}</a>
    </Link>
  )
}

const MemberCard = ({ member }) => {
  const { locale } = useRouter()

  return (
    <div className="flex rounded bg-white/50 p-2 md:basis-1/2 lg:basis-1/4">
      {member.mainImage && (
        <div className="shrink-0 basis-1/3 pr-4">
          <MemberLink member={member}>
            <div className="relative aspect-square w-full">
              <Image
                src={imageUrlBuilder(client)
                  .image(member.mainImage)
                  .width(160)
                  .url()}
                alt={member.name}
                layout="fill"
              />
            </div>
          </MemberLink>
        </div>
      )}
      <div className="flex flex-col justify-between">
        <h2>
          <MemberLink member={member}>{member.name}</MemberLink>
        </h2>
        {member.region && (
          <ul>
            {member.region.map((region) => (
              <li key={`member-${member._id}-region-${region._id}`}>
                <RegionLink region={region}>{region.title[locale]}</RegionLink>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}
export default MemberCard
